import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom";
import MainPage from "./pages/MainPage";
import ManualPage from "./pages/ManualPage/ManualPage";
import SearchPage from "./pages/SearchPage/SearchPage";
import {
  fetchRepresentManualPath,
  MANUAL_TYPE,
  PLATFORM_TYPE,
  toRouteRelativePath,
} from "./util/platformNavigation";

const MANUAL_ROUTER = [
  { path: "/kt", manualType: MANUAL_TYPE.KT },
  { path: "/g", manualType: MANUAL_TYPE.G },
];

const representManualLoader = async (params) => {
  const representManualPath = await fetchRepresentManualPath(
    params.manualType,
    params.platformType,
  );
  if (representManualPath) {
    const relativePath = toRouteRelativePath(
      representManualPath,
      params.manualType,
      params.platformType,
    );
    if (relativePath) {
      return redirect(relativePath);
    }
  }
  return redirect("no-index");
};

const createChildren = (manualType, platformType) => [
  { path: ":name", element: <ManualPage /> },
  {
    path: "",
    loader: () => representManualLoader({ manualType, platformType }),
  },
  {
    path: "*",
    loader: () => representManualLoader({ manualType, platformType }),
  },
  {
    path: "searchpage/:value",
    element: <SearchPage />,
  },
];

const createManualRouter = ({ path, manualType }) => {
  if (manualType === MANUAL_TYPE.G) {
    return {
      path: path,
      loader: ({ request }) => {
        const pathName = new URL(request.url).pathname;
        const isKcp = pathName === "/g/kcp" || pathName.startsWith("/g/kcp/");
        return {
          manualType: MANUAL_TYPE.G,
          platformType: isKcp ? PLATFORM_TYPE.KCP : PLATFORM_TYPE.LEGACY,
        };
      },
      element: <MainPage />,
      children: [
        {
          path: "kcp",
          children: createChildren(MANUAL_TYPE.G, PLATFORM_TYPE.KCP),
        },
        ...createChildren(MANUAL_TYPE.G, PLATFORM_TYPE.LEGACY),
      ],
    };
  }
  return {
    path: path,
    loader: () => ({
      manualType: MANUAL_TYPE.KT,
      platformType: PLATFORM_TYPE.NONE,
    }),
    element: <MainPage />,
    children: createChildren(MANUAL_TYPE.KT, PLATFORM_TYPE.NONE),
  };
};

function InnerApp() {
  const router = createBrowserRouter([
    ...MANUAL_ROUTER.map(createManualRouter),
    {
      path: "/",
      loader: () => redirect("/kt"),
    },
    {
      path: "*",
      loader: () => redirect("/kt"),
    },
  ]);

  return <RouterProvider router={router} />;
}

export default InnerApp;
